      
<template>
    <div >
        <div class="container">
           
            <div class="center">
                 <div class="contentTop">
                <img class="bgImg" src="../../assets/imgs/myBg.png" alt="">
                <div class="userInfo" @click="testLogin()">
                    <div class="avatarBox">
                        <div class="avatar">
                            <img  class="avatarImg" :src="avatarImgSrc" alt="">
                        </div>
                    </div>
                    <div class="userRight">
                        <span class="userName">{{userName}}</span>
                        <div class="userRole" v-if="!roleName ? false : true"> 
                        <!-- <div class="userRole" v-if="roleName!=''">  -->
                            <img class="userIcon" src="@/assets/icons/wode2.png" alt="">
                            <span>{{roleName}}</span> 
                        </div>
                        <div class="level">{{level}}</div>
                    </div>
                </div>
                <div v-if="this.token" class="logout" @click="logout()">
                    <img class="logutIcon" src="@/assets/icons/logout.png" alt="">
                    退出
                </div>
            </div>
                <div class="boxShadow">
                    <van-cell title="我的收藏" is-link @click="shoucang()">
                        <template #icon>
                            <img class="icon"  src="@/assets/icons/shoucang.png" alt="">
                        </template>
                    </van-cell>
                     <van-cell title="保费合计" is-link @click="toPremium()"><!-- to="totalPremium" -->
                        <template #icon> 
                        
                            <img class="icon"  src="@/assets/icons/xubao2.png" alt="">
                        </template>
                    </van-cell>
                    <van-divider style="background:rgba(241,241,241,1);margin:0 15px" />
                    <van-cell title="客服热线" is-link @click="serviceHotline()">
                        <template #icon>
                            <img class="icon"  src="@/assets/icons/kefu.png" alt="">
                        </template>
                    </van-cell>
                </div>
                
                <!-- <van-sidebar>
                    <van-sidebar-item title="客户管理" />
                </van-sidebar> -->
                <!-- 购买用户/ 浏览用户-->
                <van-tabs v-model="tabActive" title-active-color="#F34740" inactive-color="#333333" line-width="33" sticky class="tabBg">
                    <van-tab :title="tabList[0].tabName">
                        <user-list is_order="1"></user-list>
                    </van-tab>
                    <van-tab :title="tabList[1].tabName">
                        <user-list is_order="0"></user-list>
                    </van-tab>
                </van-tabs>
                
            </div>
        </div>
        <tabbar :active="active"></tabbar>
    </div>
</template>

<script>
import tabbar from "@/components/agentTabbar"
import userList from "@/components/userList"
import { Dialog,Toast } from 'vant';
import {mapState} from "vuex"
export default {
    data() {
        return {
            active:"agentMy",
            tabActive:0,
            tabList:[{tabId:1,tabName:"购买用户"},{tabId:2,tabName:"浏览用户"}],
        };
    },
    created(){
        document.title="客户管理";
    },
    mounted(){
       if(!this.phones){
            console.log("获取手机号",this.$store.state.phones)
            this.getPhones();
        }
    },
    methods: {
        shoucang(){
            if(!this.token){
                this.$router.push({path:"/login"});
            }else{
                this.$router.push({path:'/collection'})
            }
        },
        toPremium(){
            Toast("正在开发中");
            // this.$router.push({path:"/totalPremium"});
        },
        //客服热线
        serviceHotline(){
            Dialog.confirm({
                title: '客服热线',
                message: '确认要拨打'+this.$store.state.phones.custom_phone,
            })
            .then(() => {
                // console.log("我点击了确认",this.$store.state.phones.custom_phone);
                window.location.href="tel://"+this.$store.state.phones.custom_phone;
            })
            .catch(() => {
                //  console.log("我点击了取消")
            });
        },
        getPhones(){
            this.$https.fetchPost("User/getHotline",{},{headers:{"XX-Token":this.$store.state.token}})
            .then(result=>{
                let data=result.data;
                if(data.code==1){
                    this.$store.commit('SET_PHONES',data.data)
                }
            })
        },
        //退出接口
        logout(){
            Dialog.confirm({
                title: '退出登陆',
                message: '是否确认要退出当前账号？',
            })
            .then(() => {
                this.$https.fetchPost("Login/logout",{},{headers:{"XX-Token":this.$store.state.token}})
                .then(result=>{
                    if(result.data.code==1){
                        this.$store.commit("LOGOUT");
                        this.$router.replace("/login")
                        Toast("退出成功");
                    }
                })
            })
            .catch(() => {
                //  console.log("我点击了取消")
            });
        },
        testLogin(){
            if(!this.token){
                this.$router.push({path:"/login"});
                return;
            };
        },
    },
    components:{
        tabbar,
        userList,
        [Dialog.Component.name]: Dialog.Component,
    },
    computed:{
        ...mapState(["phones","token","userInfo"]),
        avatarImgSrc(){
            return !this.token ?  require("../../assets/imgs/avatar.png") : this.userInfo.avatar;
        },
        userName(){
            return !this.token ?  "请登录" : this.userInfo.user_nickname;
        },
        roleName(){
            return !this.token ?  "" : this.userInfo.role_name;
        } ,
        level(){
            return !this.token ?  "" : this.userInfo.agent_level_str;
        },
       
    },
}
</script>

<style scoped>
    .container{
        background:transparent;
    }
    .contentTop{
        position: relative;
        height: 145px;
    }
    .bgImg{
        width: 100%;
    }
    .userInfo{
        position: absolute;
        left: 10%;
        top: 30%;
        display: flex;
        align-items: center;
    }
    .avatarBox{
        width: 65px;
        height: 65px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255,255,255,0.2);
    }
    .avatar{
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }
    .avatarImg{
        width: 100%;
        height: 100%;
    }
    .userRight{
        margin-left: 13px;
        color:rgba(255,255,255,1);
        text-align: start;
    }
    .userName{
        font-size:17px;
    }
    .userRole{
        font-size:14px;
        opacity: 0.7;
        display: flex;
        align-items: center;
        padding: 8px 0;
    }
    .level{
        font-size: 11px;
        /* padding: 8px 0; */
    }
    .userIcon{
        width: 15px;
        height: 14px;
        margin-right: 4px;
    }
    .logout{
        position: absolute;
        top: 10px;
        right: 20px;
        color: #fff;
        display: flex;
        align-items: center;
    }
    .logutIcon{
        width: 14px;
        height: 15px;
        margin-right: 4px;
    }
    .center{
        text-align: start;
        border-radius:10px 10px 0px 0px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 50px;
        overflow: scroll;
    }
    .van-cell{
        color: #666;
        font-size: 13px;
        padding: 13px;
        align-items: center;
    }
    .icon{
        width: 18px;
        height: 19px;
        margin-right: 15px;
    }
    .boxShadow{
        border-radius: 5px;
        margin:-10px 12px 6px 12px;
        overflow: hidden;
        box-shadow: 0px -1px 3px 2px rgba(0,0,0,0.06); 

    }
    .center /deep/ .van-tab{
        font-size: 14px;
        color: #333;
    }
    .center /deep/ .van-tabs__nav{
        background: #f5f5f5;
        
    }
     .center /deep/ .van-tabs__line{
        bottom: 0.5rem;
        background: linear-gradient(left,#F34740,#FE8E89); /* 标准的语法（必须放在最后） */
    }
    .center /deep/ .van-tabs__content{
        margin-top: 4px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0px -1px 3px 2px rgba(0,0,0,0.06); 
    }
</style>


// WEBPACK FOOTER //
// src/views/agentMy/agentMy.vue